import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CreditCardVaultState } from '../reducers/credit-card-vault.reducer';

export const selectCreditCardVaultState = createFeatureSelector<CreditCardVaultState>('creditCardVault');

// Selectores básicos
export const selectVaultedCards = createSelector(selectCreditCardVaultState,(state) => state.cards);

export const selectSelectedVaultedCard = createSelector(selectCreditCardVaultState,(state) => state.selectedCard);

export const selectDefaultCard = createSelector(selectVaultedCards,(cards) => cards.find(card => card.default));

export const selectLoadingCards = createSelector(selectCreditCardVaultState,(state) => state.loading);

export const selectLoaded = createSelector(selectCreditCardVaultState,(state) => state.loaded);

export const selectCreating = createSelector(selectCreditCardVaultState,(state) => state.creating);

export const selectDeleting = createSelector(selectCreditCardVaultState,(state) => state.deleting);

export const selectUpdating = createSelector(selectCreditCardVaultState,(state) => state.updating);

export const selectErrorCards = createSelector(selectCreditCardVaultState,(state) => state.error);

export const selectDefaultVaultedCard = createSelector(selectCreditCardVaultState,(state) => state.cards.find(card => card.default) || null);

export const selectTokenAssociatedCard = createSelector(selectCreditCardVaultState,(state) => state.tokenAssociatedCard);
  
export const selectTokenFromAssociatedCard = createSelector(selectTokenAssociatedCard,(tokenAssociatedCard) => tokenAssociatedCard?.cardAccount?.token ?? null);
  
export const selectIdFromAssociatedCard = createSelector(selectTokenAssociatedCard,(tokenAssociatedCard) => tokenAssociatedCard?.id ?? null);
  
export const selectHasContractFromAssociatedCard = createSelector(selectTokenAssociatedCard,(tokenAssociatedCard) => tokenAssociatedCard?.cardAccount?.hasContract ?? false);

export const selectGuestCardSummary = createSelector(selectCreditCardVaultState, (state) => state.guestCardSummary);
